import _ from 'lodash'
import API from 'mg-api-node'
import { promisify } from 'util'

import { insertGeotabCompany } from '../../action/GeotabActions';

export function getConvertedURL(url) {
	const env = location.hostname
	let domain = ''

	switch (env) {
	case 'dev.roscocloud.com':
		domain = 'geotabdev'
		break
	case 'test.roscocloud.com':
		domain = 'geotabtest'
		break
	case 'localhost':
	case 'staging.roscocloud.com':
		domain = 'geotabstaging'
		break
	case 'roscocloud.com':
	case 'www.roscocloud.com':
	case 'fleet.roscolive.com':
		return url
	default:
		break
	}

	return url.replace(/geotab/, domain)
}

export function getAddinConfig() {
	const env = location.hostname
	let ac = _.cloneDeep(constants.ADDIN_CONFIG);
	let domain = ''

	switch (env) {
	case 'dev.roscocloud.com':
		domain = 'geotabdev'
		break
	case 'test.roscocloud.com':
		domain = 'geotabtest'
		break
	case 'localhost':
	case 'staging.roscocloud.com':
		domain = 'geotabstaging'
		break
	case 'roscocloud.com':
	case 'www.roscocloud.com':
	case 'fleet.roscolive.com':
		return ac
	default:
		break
	}

	ac.items = ac.items.map(item => {
		if (item.url) {
			item.url = item.url.replace(/geotab/, domain)
		} else if (item.mapScript && item.mapScript.src) {
			item.mapScript.src = item.mapScript.src.replace(/geotab/, domain)
		}

		return item
	})

	return ac
}

export const constants = {
	ADDIN_CONFIG: {
		name: 'Dual-Vision Video Camera',
		supportEmail: 'techsupport@roscovision.com',
		version: '2.24.0',
		items: [
			{
				menuId: 'RoscoLive',
				svgIcon: 'https://geotab.roscocloud.com/images/rosco_logo.svg',
				// icon: 'https://geotab.roscocloud.com/images/icon.png',
				menuName: {
					en: 'RoscoLive',
				},
			},
			{
				url: 'https://geotab.roscocloud.com/events.html',
				svgIcon: 'https://geotab.roscocloud.com/images/rosco_events.svg',
				path: 'RoscoLive/',
				menuName: {
					en: 'Camera Events',
				},
			},
			{
				url: 'https://geotab.roscocloud.com/vehicles.html',
				svgIcon: 'https://geotab.roscocloud.com/images/rosco_vehicles.svg',
				path: 'RoscoLive/',
				menuName: {
					en: 'Camera Admin',
				},
			},
			{
				url: 'https://geotab.roscocloud.com/video.html',
				svgIcon: 'https://geotab.roscocloud.com/images/rosco_live_video.svg',
				path: 'RoscoLive/',
				menuName: {
					en: 'Live Video',
				},
			},
			{
				url: 'https://geotab.roscocloud.com/notifications.html',
				svgIcon: 'https://geotab.roscocloud.com/images/rosco_notifications.svg',
				path: 'RoscoLive/',
				menuName: {
					en: 'Notification Portal',
				},
			},
			{
				page: 'map',
				title: 'ROSCOlive',
				mapScript: {
					src: 'https://geotab.roscocloud.com/maptools.js?SameSite=None',
				},
			},
			{
				page: 'tripsHistory',
				title: 'ROSCOlive',
				noView: true,
				mapScript: {
					src: 'https://geotab.roscocloud.com/triptools.js?SameSite=None',
				},
			},
		],
		solutionId: 'roscoDV6',
		isSigned: false,
	},
}

// FWSD-4475
export async function geotabAuthentication(initData, refreshInitData) {
	console.log('geotabAuthentication initData1: ', initData)
	const data = { ...initData }

	let geotabApi
	let resAuth
	// if geotab_company contains stored session_id then makes geotab API instance with session_id (without password) 
	// and verifies credentials via apiv1/Get?typeName=User geotab request
	if (data.sessionId) {
		try {
			geotabApi = new API(
				data.email,
				null,
				data.database,
				data.path,
				null,
				data.sessionId,
			)
		}
		catch (errAPI) {
			console.log('!Error Geotab authentication errAPI: ', errAPI);
		}

		// verifies credentials (is session_id still actual) via apiv1/Get?typeName=User geotab request
		try {
			const call = promisify(geotabApi.call);

			resAuth = await call('Get', {
				typeName: 'User',
				resultsLimit: 1,
			});

			data.email = geotabApi.credentials.userName;
			data.database = geotabApi.credentials.database;
			data.sessionId = geotabApi.credentials.sessionId;
		} catch (errAuth) {
			console.log('!Error Geotab authentication errAuth1: ', errAuth);
			// toastr.error('An unexpected error occurred. Please try again later');
			// return;
		}
	}

	// if session_id isn't actual then then makes geotab API instance with password,
	// makes geotab authentication with stored password and generates new session_id which should be stored to the geotab_company table
	if (!resAuth) {
		try {
			geotabApi = new API(
				data.email,
				data.password,
				data.database,
				data.path,
			)

			const authenticate = promisify(geotabApi.authenticate); // forces return Promise from api.authenticate
			// call = promisify(geotabApi.call);

			resAuth = await authenticate();

			data.email = resAuth.credentials.userName;
			data.database = resAuth.credentials.database;
			data.sessionId = resAuth.credentials.sessionId;

			// stores to the geotab_company table new generated session_id
			insertGeotabCompany(data)
				.then(() => {
					if (typeof refreshInitData === 'function') {
						return refreshInitData()
					}
					// getCompanyGeotabData()
				})
				.catch((error) => {
					console.log('!insertGeotabCompany error: ', error.response, error);
				});

		}
		catch (errAuth) {
			console.log('!Error Geotab authentication errAuth2: ', errAuth);
			return { error: true }
		}
	}

	console.log('GeitabAPI: ', geotabApi);

	return { geotabApi, geotabData: data }
}
